import classNames from 'styles/utils/classNames';

const FilterBox = ({
  label,
  selected,
  value,
  onClick,
}: {
  label: string;
  selected: boolean;
  value: string;
  onClick: () => void;
}) => (
  <button
    value={value}
    onClick={onClick}
    type="button"
    className={classNames(
      'typography-product-element-label h-10 px-6',
      selected
        ? 'bg-color-bg-lightmode-invert text-color-text-lightmode-invert dark:bg-color-bg-darkmode-invert dark:text-color-text-darkmode-invert'
        : 'bg-color-bg-lightmode-secondary text-color-text-lightmode-secondary dark:bg-color-bg-darkmode-secondary dark:text-color-text-darkmode-secondary',
    )}
  >
    {label}
  </button>
);

export default FilterBox;
